<template>
  <b-modal
    v-model="activModel"
    centered
    :title="`${type != 'ADD' ? 'تعديل ' : 'إضافة '}`"
    id="modal-employees"
    footer-class="removed"
    cancel-variant="outline-secondary"
    size="xl"
    no-close-on-backdrop
  >
    <validation-observer ref="founderValidation">
      <b-form class="auth-login-form mt-2" @submit.prevent>
        <div class="model_events">
          <b-row>
            <b-col cols="12">
              <h3>المعلومات الشخصية</h3>
              <hr />
            </b-col>
            <b-col cols="3">
              <form-input
                rules="required"
                id="first_name"
                label="الاسم الأول*"
                v-model="infoModal.first_name"
              />
            </b-col>

            <b-col cols="3">
              <form-input
                rules="required"
                id="last_name"
                label="الكنية*"
                v-model="infoModal.last_name"
              />
            </b-col>
            <b-col cols="3">
              <form-input
                rules="required"
                id="father_name"
                label="اسم الأب*"
                v-model="infoModal.father_name"
              />
            </b-col>
            <b-col cols="3">
              <form-input
                rules="required"
                id="mother_name"
                label="اسم الأم*"
                v-model="infoModal.mother_name"
              />
            </b-col>
            <b-col cols="3">
              <form-mask
                label="الرقم الوطني*"
                id="id-num"
                v-model="infoModal.id_number"
                options="blockNomber11"
                rules="required"
              />
            </b-col>
            <b-col md="3">
              <form-mask
                label="رقم التواصل*"
                id="id-num"
                v-model="infoModal.contact_number"
                options="blockNomber10"
                rules="required"
              />
            </b-col>

            <b-col cols="3">
              <form-select
                id="options_gander"
                :options="optionsGander"
                label="الجنس*"
                :reduce="(x) => x.value"
                :getOptionLabel="(x) => x.title"
                v-model="infoModal.gander"
                rules="required"
              />
            </b-col>

            <b-col cols="3">
              <form-mask
                options="date"
                placeholder="YYYY-MM-DD"
                id="infoModal_birthday"
                v-model="infoModal.birthday"
                label="تاريخ الميلاد*"
                rules="required"
              />
            </b-col>

            <b-col cols="3">
              <form-select
                id="select_holds_disability_card_employee"
                :options="optionsIs_holds_disability_card"
                label="يحمل بطاقة إعاقة"
                :reduce="(x) => x.value"
                :getOptionLabel="(x) => x.title"
                v-model="infoModal.is_holds_disability_card"
              />
            </b-col>

            <b-col cols="3">
              <form-input
                rules="required"
                id="address"
                label="عنوان السكن*"
                v-model="infoModal.address"
              />
            </b-col>
            <b-col cols="12">
              <h3>المعلومات الوظيفية</h3>
              <hr />
            </b-col>

            <b-col cols="3">
              <form-select
                label="الفرع*"
                v-model="infoModal.branch_id"
                :getOptionLabel="(x) => x.governorate_name"
                :reduce="(x) => x.id"
                id="branch_id_"
                ep="v2/selects/branches"
                rules="required"
              />
            </b-col>

            <b-col cols="3">
              <form-input
                rules="required"
                id="position"
                label="المنصب الوظيفي*"
                v-model="infoModal.position"
              />
            </b-col>
            <b-col cols="3">
              <form-input
                rules="required"
                id="work"
                label="العمل*"
                v-model="infoModal.work"
              />
            </b-col>
            <b-col cols="3" v-if="rouls != 1 && $route.name == 'employees'">
              <form-mask
                options="date"
                placeholder="YYYY-MM-DD"
                id="employment_date"
                v-model="infoModal.employment_date"
                label="تاريخ بداية التوظيف*"
                rules="required"
              />
            </b-col>
            <b-col cols="3" v-if="type != 'ADD'">
              <form-mask
                options="date"
                placeholder="YYYY-MM-DD"
                id="infoModal_resignation"
                v-model="infoModal.resignation"
                label="تاريخ الاستقالة"
              />
            </b-col>

            <b-col cols="3" v-if="$route.name == 'employees'">
              <form-mask
                id="insurance_number"
                options="blockNomberIndeterminate"
                label="رقم التأمينات"
                v-model="infoModal.insurance_number"
              />
            </b-col>
            <b-col cols="3" v-if="$route.name == 'employees'">
              <form-mask
                id="number_employee"
                options="blockNomberIndeterminate"
                label="رقم التوظيف ضمن المنظمة"
                v-model="infoModal.code"
              />
            </b-col>
            <b-col cols="3">
              <form-select
                label="المؤهلات العلمية"
                ep="v2/selects/qualifications"
                v-model="infoModal.qualification_id"
                id="qualification"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.title"
                rules="required"
              />
            </b-col>
            <b-col cols="3">
              <form-select
                id="member_status"
                :options="optionSmember_status"
                label="حالة العضو*"
                :reduce="(x) => x.value"
                :getOptionLabel="(x) => x.title"
                v-model="infoModal.member_status"
                rules="required"
              />
            </b-col>
          </b-row>
        </div>

        <div class="d-flex justify-content-end">
          <b-button
            variant="secondary"
            class="mx-1"
            @click="activModel = false"
          >
            إلغاء <feather-icon icon="Trash2Icon" />
          </b-button>
          <b-button
            v-if="type == 'ADD'"
            type="submit"
            variant="primary"
            @click="formSubmitCreate"
          >
            إضافة <feather-icon icon="EditIcon" />
          </b-button>

          <b-button
            v-else
            variant="primary"
            type="submit"
            @click="formSubmitEdit"
          >
            تعديل <feather-icon icon="EditIcon" />
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import "quill/dist/quill.snow.css";
import FormMask from "@/components/form-mask";

import { quillEditor } from "vue-quill-editor";
import { ValidationObserver } from "vee-validate";

import {
  BModal,
  BRow,
  BButton,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BFormTimepicker,
  BForm,
  BCol,
} from "bootstrap-vue";
import FormSelect from "@/components/form-select/index.vue";
import FormInput from "@/components/form-input/index.vue";
import FormDatepicker from "@/components/form-datepicker/index.vue";
export default {
  props: {
    value: Boolean,
    info: Object,
    type: String,
  },
  components: {
    FormDatepicker,
    FormMask,
    quillEditor,
    BModal,
    BRow,
    BButton,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    BFormTimepicker,
    FormSelect,
    BForm,
    BCol,
    FormInput,
    ValidationObserver,
  },
  data: () => ({
    rouls: null,
    infoModal: {
      id: "",
      code: "",
      insurance_number: "",
      first_name: "",
      last_name: "",
      father_name: "",
      mother_name: "",
      branch_id: null,
      birthday: "",
      id_number: null,
      position: "",
      contact_number: "",
      address: "",
      work: "",
      employment_date: "",
      qualification_id: null,
      start_date: "",
      is_holds_disability_card: "",
      gander: "",
      member_status: "",
    },
    optionsIs_holds_disability_card: [
      { value: 1, title: "نعم" },
      { value: 0, title: "لا" },
    ],
    optionsGander: [
      { value: 1, title: "ذكر" },
      { value: 0, title: "أنثى" },
    ],
    optionSmember_status: [
      { value: 1, title: "نشط" },
      { value: 0, title: "غير نشط" },
    ],
  }),

  methods: {
    formSubmitCreate() {
      this.$refs.founderValidation.validate().then(async (success) => {
        if (success) {
          if (this.$route.name == "employees") {
            this.addFounder();
          } else {
            this.addVoulunteer();
          }
        }
      });
    },

    formSubmitEdit() {
      this.$refs.founderValidation.validate().then(async (success) => {
        if (success) {
          if (this.$route.name == "employees") {
            this.editFounder();
          } else {
            this.editVolunteer();
          }
        }
      });
    },

    unFilter() {
      for (const key in this.infoModal) {
        if (Object.hasOwnProperty.call(this.infoModal, key)) {
          this.infoModal[key] = "";
        }
      }
    },

    initState() {
      for (const key in this.infoModal) {
        if (Object.hasOwnProperty.call(this.infoModal, key)) {
          if (key == "branch_id") {
            this.infoModal[key] = this.info["branch"]
              ? this.info["branch"].id
              : null;
          } else this.infoModal[key] = this.info[key];
        }
      }
    },

    editFounder() {
      this.$store.dispatch("AdministrativeStatus/Employees/upDateEmployee", {
        id: this.infoModal.id,

        data: {
          ...this.infoModal,
          is_employee: 1,
        },
      });
      this.activModel = false;
    },

    editVolunteer() {
      this.$store.dispatch("AdministrativeStatus/Employees/upDateVolunteer", {
        id: this.infoModal.id,

        data: {
          ...this.infoModal,
          is_employee: 1,
        },
      });
      this.activModel = false;
    },

    addFounder() {
      this.$store.dispatch("AdministrativeStatus/Employees/submitEmployee", {
        data: {
          ...this.infoModal,
          employee_role_id: 5,
        },
      });
      this.activModel = false;
      this.unFilter();
    },

    addVoulunteer() {
      this.$store.dispatch("AdministrativeStatus/Employees/submitVolunteer", {
        data: {
          ...this.infoModal,
        },
      });
      this.activModel = false;
      this.unFilter();
    },
  },

  computed: {
    activModel: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    info() {
      this.initState();
    },
    type(val) {
      if (val == "ADD") {
        this.unFilter();
      }
    },
  },
  created() {
    if (this.type != "ADD") {
      this.initState();
    } else {
      this.unFilter();
    }
  },
};
</script>
